module.exports = __webpack_public_path__ + "static/media/fdcr.64c57fbc.jpg";